/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { HiMiniBoltSlash, HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  IconButton,
  Menu,
  MenuItem
} from '@mui/material' // Npm: Material UI components.


/*
 * OBJECTS
 */
const Index = ({
  type,
  mergedIPs,
  isMulti,
  customerAccountId,
  customerAccountIds,
  onCustomerBlockDuration,
  onCustomerAccountUpdate,
  onCustomerAccountDelete,
  PassOnUpdate
}) => {
  // Hook assignment.
  const [_anchorEl, _setAnchorEl] = React.useState(null)
  const _open = Boolean(_anchorEl)

  const _handleClick = (event) => {
    _setAnchorEl(event.currentTarget)
  }

  const _handleClose = () => {
    _setAnchorEl(null)
  }

  // Return component.
  return (
    <>
      <IconButton
        onClick={_handleClick}
        sx={{
          margin: 'auto',
          borderRadius: '8px',
          color: 'gray.500',
          backgroundColor: 'transparent'
        }}>
        <HiPencil size={18} />
      </IconButton>
      <Menu
        anchorEl={_anchorEl}
        open={_open}
        onClose={_handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            backgroundColor: '#ffffff',
            color: 'rgba(22, 22, 22, 0.5)',
            fontFamily: 'DM Sans',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '24px',
            letterSpacing: '-.26px',
            borderRadius: '24px',
            boxShadow: '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
            maxHeight: '400px',
            overflowY: 'auto'
          }
        }}>
        <MenuItem
          onClick={() => {
            // Push customerAccount id to url.
            PassOnUpdate({
              customerAccountId,
              customerAccountIds: isMulti ? customerAccountIds : [customerAccountId],
              type,
              mergedIPs,
              isMulti
            })

            // Execute handler.
            onCustomerAccountUpdate()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiPencil size={18} />
          <span>Edit Customer Account</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerAccountId, customerAccountIds, type })

            // Execute handler.
            onCustomerBlockDuration()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiMiniBoltSlash size={18} />
          <span>Block Traffic</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push customerAccount id to url.
            PassOnUpdate({ customerAccountId, customerAccountIds, isMulti })

            // Execute handler.
            onCustomerAccountDelete()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiTrash size={18} />
          <span>Delete Customer Account</span>
        </MenuItem>
      </Menu>
    </>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'type': PropTypes.string,
  'customerAccountId': PropTypes.string,
  'customerAccountIds': PropTypes.array,
  'mergedIPs': PropTypes.string,
  'isMulti': PropTypes.bool,
  'onCustomerBlockDuration': PropTypes.func,
  'onCustomerAccountUpdate': PropTypes.func,
  'onCustomerAccountDelete': PropTypes.func,
  'PassOnUpdate': PropTypes.func
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
